import settings from './settings';

const api = {
  settings,
};


export default api;
